import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConsentimientoService {
  private apiUrl = '/api/config/consentimiento';

  constructor(private http: HttpClient) {}

  // Registrar consentimiento
  registrarConsentimiento(data: {
    usuario_id: number;
    ip_aceptacion: string;
    version_politica: string;
  }): Observable<any> {
    return this.http.post(`${this.apiUrl}/consentimiento`, data);
  }

  // Obtener consentimientos con paginación y búsqueda
  obtenerConsentimientos(
    page: number = 1,
    limit: number = 25,
    search: string = ''
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get(`${this.apiUrl}/consentimiento`, { params });
  }

  // Obtener consentimiento por usuario
  obtenerPorUsuario(usuario_id: number): Observable<any> {
    const params = new HttpParams().set('usuario_id', usuario_id.toString());
    return this.http.get(`${this.apiUrl}/consentimiento/por-usuario`, {
      params,
    });
  }

  // Subir nuevo archivo PDF de política
  subirPolitica(file: File, version: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('version', version);
    return this.http.post(`${this.apiUrl}/politica/upload`, formData);
  }
  // Obtener política vigente
  obtenerPoliticaVigente(): Observable<any> {
    return this.http.get(`${this.apiUrl}/consentimiento/politica`);
  }
}
